module.exports = __webpack_public_path__ + "static/img/title.392813c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/loginImg/title.png
// module id = KPvq
// module chunks = 18